/* eslint-disable jsx-a11y/heading-has-content */
import * as React from "react"

const Card = (props: React.ComponentProps<"div">) => <div {...props} />
Card.displayName = "Card"

const CardHeader = (props: React.ComponentProps<"div">) => <div {...props} />
CardHeader.displayName = "CardHeader"

const CardTitle = (props: React.ComponentProps<"h3">) => <h3 {...props} />
CardTitle.displayName = "CardTitle"

const CardDescription = (props: React.ComponentProps<"p">) => <p {...props} />
CardDescription.displayName = "CardDescription"

const CardContent = (props: React.ComponentProps<"div">) => <div {...props} />
CardContent.displayName = "CardContent"

const CardFooter = (props: React.ComponentProps<"div">) => <div {...props} />
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
